import { Container, Form, Button, Table, Col } from 'react-bootstrap';
import React, { useState, useRef } from 'react';
import { root_url } from '../setting';
import { useReactToPrint } from 'react-to-print';
import MapAPI from './MapAPI';
import axios from 'axios';
const UntactRecord = () => {
  const [photos, setPhotos] = useState([]);
  const [recordResult, setRecordResult] = useState([]);
  const [result, setResult] = useState(false);
  const [name, setName] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [reservationNumber, setReservationNumber] = useState('');
  const [certificate, setCertificate] = useState({
    runnerName: '',
    elapseTime: '',
    ticketName: '',
    backNo: '',
    issueDate: '',
  });
  const [record, setRecord] = useState({});
  const handlePrint = useReactToPrint({
    content: () => componentToPrintRef.current,
  });

  const componentToPrintRef = useRef();

  const [mapInfo, setMapInfo] = useState({
    name: '',
    ticketName: '',
    startTime: '',
    endTime: '',
    distance: '',
    durationTime: '',
  });
  const [runners, setRunners] = useState([]);
  const onChangeName = (e) => {
    setName(e.target.value);
  };
  const onChangePhoneNum = (e) => {
    setPhoneNum(e.target.value);
  };

  const onChangeReservationNumber = (e) => {
    setReservationNumber(e.target.value);
  };
  const onPressPhoneNum = (e) => {
    if (e.key >= 0 && e.key <= 9) {
      return true;
    } else e.preventDefault();
  };
  const addZero = (tmp) => {
    return parseInt(tmp) < 10 ? '0' + tmp : tmp;
  }
  const getRoute = async (runner) => {
    console.log('## getRoute ##', runner);
    setResult(false);
    try {
      let response = await axios.post(`${root_url}/api/v1/footprint`, {
        joinSeq: reservationNumber,
        runnerSeq: runner.runnerSeq,
        runnerName: runner.runnerName,
        cellphone: runner.cellphone
      });
      let traces = response.data.traces;
      let photos = response.data.photos;
      let certificate = response.data.certificate;
      let record = response.data.record;

      setRecord(record);
      setCertificate(certificate);
      setPhotos(photos);
      console.log('response --> ', response.data);
      if (traces.length == 0) {
        alert('아직 참여하지 않은 대회이거나, 어플을 이용하지 않은 대회 참가자입니다.');
        return;
      } else {
        // let timeTmp = new Date(traces[0].logtime);
        // let startTime =
        //   addZero(timeTmp.getFullYear()) + '년 '
        //   + addZero(timeTmp.getMonth() + 1) + '월 '
        //   + addZero(timeTmp.getDate()) + '일 '
        //   + addZero(timeTmp.getHours()) + ':'
        //   + addZero(timeTmp.getMinutes()) + ':'
        //   + addZero(timeTmp.getSeconds());

        // timeTmp = new Date(traces[traces.length - 1].logtime);
        // let endTime =
        //   addZero(timeTmp.getFullYear()) + '년 '
        //   + addZero(timeTmp.getMonth() + 1) + '월 '
        //   + addZero(timeTmp.getDate()) + '일 '
        //   + addZero(timeTmp.getHours()) + ':'
        //   + addZero(timeTmp.getMinutes()) + ':'
        //   + addZero(timeTmp.getSeconds());

        // let distance = traces[traces.length - 1].distance;

        // let startDate = new Date(traces[0].logtime);
        // let endDate = new Date(traces[traces.length - 1].logtime);
        // let durationTime = (endDate.getTime() - startDate.getTime()) / 1000;



        setResult(true);
        setRecordResult(traces);
        setMapInfo({
          name: runner.runnerName,
          ticketName: runner.ticketName,
          startTime: record.startTime,
          endTime: record.finishTime,
          durationTime: record.elapseTime,
        });
      }
    } catch (error) {
      if (error.response === undefined) {
        alert(
          '시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)'
        );
        console.log('error', error);
        return;
      } else {
        alert(error.response.data.errorMessage);
        return;
      }
    }
  }
  const onClickSubmit = async () => {
    setRunners([]);
    setResult(false);
    if (name === '' || phoneNum === '' || reservationNumber === '') {
      alert('모든 항목을 입력해주세요');
      setResult(false);
    } else {
      let response;
      try {
        response = await axios.post(`${root_url}/api/untact/search`, {
          joinSeq: reservationNumber,
          joinerName: name,
          cellphone: phoneNum
        });
        let runnerArray = response.data.runners;
        if (runnerArray.length == 0) {
          alert('언택트 기록이 존재하지 않습니다.');
        } else if (runnerArray.length == 1) {
          getRoute(runnerArray[0]);
        } else {
          setRunners(runnerArray);
        }
      } catch (error) {
        //error메시지가 있다면 보여줘야함
        if (error.response === undefined) {
          alert(
            '시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)'
          );
          return;
        } else {
          alert(error.response.data.errorMessage);
          return;
        }
      }

    }
  };
  return (
    <Container>
      <div>
        <h1 className="mt-3 mb-5">언택트 기록 조회</h1>
        <Form.Group controlId="formName" className="mt-3 me-5 d-inline-block">
          <Form.Label>이름</Form.Label>
          <Form.Control
            type="text"
            placeholder="홍길동"
            value={name}
            onChange={onChangeName}
          />
        </Form.Group>
        <Form.Group
          controlId="formPhoneNumber"
          className="mt-3 me-5 d-inline-block"
        >
          <Form.Label>전화번호</Form.Label>
          <Form.Control
            type="text"
            placeholder="01012345678(-없이 입력)"
            value={phoneNum}
            onChange={onChangePhoneNum}
            onKeyPress={onPressPhoneNum}
          />
        </Form.Group>
        <Form.Group
          controlId="formReserveNumber"
          className="mt-3 mb-5 me-5 d-inline-block"
        >
          <Form.Label>접수번호</Form.Label>
          <Form.Control
            type="text"
            placeholder="30101"
            value={reservationNumber}
            onChange={onChangeReservationNumber}
          />
        </Form.Group>
        <Button
          className="bg-custom-color"
          style={{ border: 'none' }}
          onClick={onClickSubmit}
        >
          기록 조회
        </Button>
      </div>
      <div>
        {runners.map((item, key) => {
          console.log(item);
          return <div><p onClick={() => { getRoute(item) }} style={{ cursor: 'pointer' }}>{item.ticketName}</p></div>
        })}
      </div>
      {result === false ? (
        ''
      ) : (
        <div className="mt-5 row">
          <Col><h5>{mapInfo.name}님의 [{mapInfo.ticketName}] 기록</h5></Col>
          <Col>
            {
              ((certificate != null) && (certificate?.runnerName !== '')) ?
                <Button
                  className="bg-custom-color"
                  style={{ border: 'none' }}
                  onClick={() => {
                    handlePrint();
                  }}
                >
                  기록증 출력하기
                </Button> : ''
            }
          </Col>

          <div style={{ width: '100%', height: '40vh', position: 'relative' }}>
            <MapAPI result={recordResult} />
          </div>
          {/* <Pill
            title="출발 시간"
            content={mapInfo.startTime}
            width="20rem"
            margin="1rem"
            className="d-inline-block"
            isInlineBlock="true"
          />
          <Pill
            title="도착 시간"
            content={mapInfo.endTime}
            width="20rem"
            margin="1rem"
            className="d-inline-block"
            isInlineBlock="true"
          />
          <Pill
            title="이동 거리"
            content={`${mapInfo.distance == undefined ? 0 : (mapInfo.distance / 1000).toFixed(3)}km`}
            width="20rem"
            margin="1rem"
            className="d-inline-block"
            isInlineBlock="true"
          />
          <Pill
            title="소요 시간"
            content={`${parseInt(mapInfo.durationTime/60)}분 ${mapInfo.durationTime%60}초`}
            width="20rem"
            margin="1rem"
            className="d-inline-block"
            isInlineBlock="true"
          /> */}
          <Table className="text-center mt-5">
            <tbody>
              <tr style={{ backgroundColor: "#2d75d1", color: "white" }}><td>출발시간</td><td>도착시간</td><td>소요시간</td></tr>
              <tr><td>{mapInfo.startTime}</td><td>{mapInfo.endTime}</td><td>{parseInt(mapInfo.durationTime/3600)}시간 {parseInt((mapInfo.durationTime%3600)/60)}분 {(mapInfo.durationTime%60)}초</td></tr>
            </tbody>

          </Table>
          <div style={{ textAlign: "center" }}>
            {photos.map((item, key) => {
              return <img src={`${root_url}/api/photo/${item}`} alt="#" key={key} style={{ marginRight: "20px", marginBottom: "20px" }} />
            })}
          </div>
        </div>
      )}
      {
        certificate == null ? '' : <ComponentToPrint ref={componentToPrintRef} certificate={certificate} />
      }
      
    </Container>
  );
};
class ComponentToPrint extends React.Component {
  render() {
    const { runnerName, elapseTime, ticketName, backNo, issueDate } = this.props.certificate;
    return (
      <div
        className="backno"
        style={{
          height: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundImage: 'url(/마라톤기록증.png)',
          backgroundRepeat: 'no-repeat',
          fontSize: '1.5rem',
          fontWeight: 'bold',
        }}
      >
        <p style={{ paddingTop: '27.6rem', paddingLeft: '20rem' }}>{runnerName}</p>
        <p style={{ paddingTop: '2.6rem', paddingLeft: '21rem' }}>{parseInt(elapseTime.split(":")[0])>0? parseInt(elapseTime.split(":")[0]) + "시간 " + parseInt(elapseTime.split(":")[1]) + "분 " + parseInt(elapseTime.split(":")[2]) + "초" :  parseInt(elapseTime.split(":")[1]) + "분 " + parseInt(elapseTime.split(":")[2]) + "초" }</p>
        <p style={{ paddingTop: '2.5rem', paddingLeft: '21rem' }}>
          {ticketName}
        </p>
        <p style={{ paddingTop: '2.4rem', paddingLeft: '26rem' }}>{backNo}</p>
        <p style={{ paddingTop: '8rem' }} className="text-center">
          {issueDate}
        </p>
      </div>
    );
  }
}
export default UntactRecord;
